import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import store from "store";
import { setConfig } from "appredux/configSlice";
import Sider from "./Sider";
import {
  isMobileViewSelector,
  isMobileMenuOpenSelector,
  isMenuCollapseSelector,
} from "appredux/selectors";
import { Button, Drawer } from "antd";
import { AppstoreOutlined, CloseOutlined } from "@ant-design/icons";
import useRemainingBalance from "hooks/useRemainingBalance";

const SideMenu = () => {
  const dispatch = useDispatch();

  const isMobileView = useSelector(isMobileViewSelector);
  const isMobileMenuOpen = useSelector(isMobileMenuOpenSelector);
  const isMenuCollapsed = useSelector(isMenuCollapseSelector);
  const { isChatRestricted } = useRemainingBalance();

  const toggleDrawerHandler = useCallback(() => {
    store.set("app.settings.isMobileMenuOpen", !isMobileMenuOpen);
    store.set("app.menu.isMenuCollapsed", !isMenuCollapsed);
    dispatch(
      setConfig({
        isMobileMenuOpen: !isMobileMenuOpen,
        isMenuCollapsed: !isMenuCollapsed,
      })
    );
  }, [dispatch, isMenuCollapsed, isMobileMenuOpen]);

  if (isMobileView) {
    return (
      <>
        <Drawer
          title="Basic Drawer"
          placement="left"
          closable={false}
          onClose={toggleDrawerHandler}
          open={isMobileMenuOpen}
          width={256}
          className="relative overflow-visible"
        >
          <Sider />
          <Button
            className="absolute bottom-32 z-10 -right-10 rounded-l-none"
            onClick={toggleDrawerHandler}
            type="primary"
            icon={<CloseOutlined />}
            size="large"
          />
        </Drawer>
        <Button
          className={`fixed bottom-32 z-10 left-0 rounded-l-none ${
            isChatRestricted ? "z-[51]" : "z-10"
          }`}
          onClick={toggleDrawerHandler}
          type="primary"
          // shape="circle"
          icon={<AppstoreOutlined />}
          size="large"
        />
      </>
    );
  }
  return <Sider />;
};

export default SideMenu;
